import { css } from '@benzinga/themetron';

export const fusionSectionPadding = css`
  padding-left: 48px;
  padding-right: 48px;
  @media screen and (max-width: 1279px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media screen and (max-width: 959px) {
    padding-left: 24px;
    padding-right: 24px;
  }
  @media screen and (max-width: 567px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const fusionSectionContentPadding = css`
  @media screen and (max-width: 1386px) {
    ${fusionSectionPadding}
  }
`;
